import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-search\"><path d=\"M8.244 14.528a6.229 6.229 0 0 0 4.051-1.477l4.923 4.923a.563.563 0 0 0 .408.169.577.577 0 0 0 .408-.985l-4.923-4.923a6.334 6.334 0 0 0 1.477-4.051A6.345 6.345 0 0 0 8.244 1.84C4.756 1.84 1.9 4.696 1.9 8.184c0 3.502 2.856 6.344 6.344 6.344Zm0-11.534c2.87 0 5.19 2.335 5.19 5.19 0 2.87-2.32 5.19-5.19 5.19a5.196 5.196 0 0 1-5.19-5.19 5.205 5.205 0 0 1 5.19-5.19Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol